import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalH2, LegalP, LegalLastUpdated } from './LegalPages';

export function AcceptableUsePage() {
  const { t } = useTranslation();
  return (
    <LegalShell titleKey="acceptable_use.title">
      <LegalLead>{t('acceptable_use.lead')}</LegalLead>

      <LegalH2>{t('acceptable_use.content_title')}</LegalH2>
      <LegalP>{t('acceptable_use.content_body')}</LegalP>

      <LegalH2>{t('acceptable_use.use_title')}</LegalH2>
      <LegalP>{t('acceptable_use.use_body')}</LegalP>

      <LegalH2>{t('acceptable_use.sanctions_title')}</LegalH2>
      <LegalP>{t('acceptable_use.sanctions_body')}</LegalP>

      <LegalH2>{t('acceptable_use.enforcement_title')}</LegalH2>
      <LegalP>{t('acceptable_use.enforcement_body')}</LegalP>

      <LegalH2>{t('acceptable_use.reporting_title')}</LegalH2>
      <LegalP>
        {t('acceptable_use.reporting_body_prefix')}{' '}
        <code className="text-ink-900 font-mono">{t('acceptable_use.reporting_email')}</code>{' '}
        {t('acceptable_use.reporting_body_suffix')}
      </LegalP>

      <LegalLastUpdated>{t('acceptable_use.last_updated')}</LegalLastUpdated>
    </LegalShell>
  );
}
